<template>
  <main class="roles-page">
    <HeroSection :page="page" />
    <BenefitsSection is-dark />
    <RoleDescriptionSection :page="page" />
    <WhyProxify />
    <HowItWorksSection />
    <div :class="{ container: !isTablet }">
      <SearchSection
        class="search-section"
        search-title="Search more roles"
      />
    </div>
    <OurReachSection />
    <FaqSection />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import BenefitsSection from '~/components/Common/BenefitsSection/BenefitsSection.vue';
import RoleDescriptionSection from './RoleDescriptionSection/RoleDescriptionSection.vue';
import WhyProxify from './WhatWeOfferSection/WhyProxify.vue';
import HowItWorksSection from './HowItWorksSection/HowItWorksSection.vue';
import SearchSection from '~/components/Common/SearchSection/SearchSection.vue';
import OurReachSection from '~/components/Common/OurReachSection/OurReachSection.vue';
import FaqSection from '~/components/Common/FaqSection/FaqSection.vue';
import isTablet from '~/mixins/responsive';

export default {
  components: {
    HeroSection,
    BenefitsSection,
    RoleDescriptionSection,
    WhyProxify,
    HowItWorksSection,
    SearchSection,
    OurReachSection,
    FaqSection,
  },
  mixins: [isTablet],
  props: {
    page: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import './RolePage.scss';
</style>
